import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ControlComponent } from './components/control/control.component';
import { ControlCreateUpdateComponent } from './components/control-create-update/control-create-update.component';


const routes: Routes = [
   
        { path: '', component: ControlComponent },
        // { path: 'crear', component: CrearControlComponent },
        // { path: 'edit/:id', component: EditControlComponent },
        { path: 'crear', component: ControlCreateUpdateComponent },
        { path: 'edit/:id', component: ControlCreateUpdateComponent },


    
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppControlRoutingModule {}
